import Image from 'next/image'
import { usePathname } from 'next/navigation'
import React from 'react'

import { authBanner } from '@/libs/constants/images-library'
export default function AuthBanner() {
  const pathname = usePathname()
  const includedPathname = ['/auth/login', '/auth/register']

  if (!includedPathname.includes(pathname)) {
    return null
  }

  return (
    <div className='right-0 hidden w-1/2 lg:flex'>
      <Image
        src={authBanner.src}
        alt={authBanner.alt}
        width={1719}
        height={1080}
        className='min-h-screen w-full object-cover'
      />
    </div>
  )
}
